export default "__VITE_ASSET__Suq3HBzl__"